import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const EventsPage = () => {
  const events = [
    { 
      title: '9-11 Reading Of The Names', 
      date: 'September 11, 2025 - 8:15am', 
      desc: '24th Anniversary of 9-11 at Veterans Community Park, Naples' 
    },
    { 
      title: 'Christmas In July', 
      date: 'July 26, 2025 10am-5pm', 
      desc: '20% off on that day only! Complimentary drinks and cookies.' 
    },
    { 
      title: 'National Night Out', 
      date: 'August 5, 2025 6pm-8pm', 
      desc: 'Join Naples Police & Firefighters at Naples Community Park!' 
    },
  ];

  return (
    <>
      <Helmet>
        <title>Community Events | Leisure Wellness Naples</title>
        <meta name="description" content="Join Leisure Wellness Naples community events. We support First Responders, Law Enforcement, Military and Veterans with a 10% discount." />
        <meta name="keywords" content="naples events, leisure wellness events, community events naples fl" />
        <meta property="og:title" content="Community Events | Leisure Wellness Naples" />
        <meta property="og:description" content="Local community events in Naples, FL." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.leisurewellnessnaples.com/events" />
      </Helmet>
    <div className="pt-36 pb-20" style={{ background: 'linear-gradient(180deg, #ffffff 0%, #E0FFFF 20%, #AFEEEE 50%, #98FB98 80%, #F0FFF0 100%)' }} data-testid="events-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          className="font-['Barlow_Condensed'] text-4xl md:text-6xl font-bold uppercase text-[#0E3D95] mb-4"
        >
          Leisure Wellness Naples Events
        </motion.h1>
        <p className="text-xl text-slate-600 mb-12">
          We believe in our community and giving back. 10% discount to First Responders, Law Enforcement, Military and Veterans.
        </p>
        
        {events.map((event, idx) => (
          <motion.div 
            key={event.title} 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            transition={{ delay: idx * 0.1 }} 
            className="bg-slate-50 p-8 mb-6"
          >
            <h2 className="font-['Barlow_Condensed'] text-3xl font-bold text-[#0E3D95] mb-2">{event.title}</h2>
            <p className="text-lg font-semibold text-[#F88200] mb-4">{event.date}</p>
            <p className="text-slate-600">{event.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
    </>
  );
};

export default EventsPage;
